/**
 * Shared IntersectionObserver configurations
 */

/**
 * Configuration for observing Package visibility in infinite scroll
 * 
 * Used to trigger sidebar stop behavior when Package becomes visible.
 * 
 * @property {string} rootMargin - '100px 0px 0px 0px'
 *   - Top margin of 100px triggers the observer slightly before the Package enters viewport
 *   - This provides a smoother transition by stopping the sidebar early, preventing
 *     the sidebar from overlapping with the Package as it comes into view
 * 
 * @property {number} threshold - 0
 *   - Triggers as soon as any part of the Package becomes visible
 *   - Using 0 (vs higher values) ensures immediate response to Package appearance
 */
export const PACKAGE_VISIBILITY_OBSERVER_CONFIG = {
  rootMargin: '100px 0px 0px 0px', // Trigger 100px before Package enters viewport
  threshold: 0, // Trigger immediately when Package becomes visible
};
